export const elmoExperimentResourceNames = {
  default: 'GOPS_smarthelp',
  pcc: 'GOPS_smarthelp_pcc',
  stepUpVenice: 'GOPS_smarthelp_venice_step_up',
  kmSearch: 'GOPS_smarthelp_km_search',
  finalIntentContactOps: 'GOPS_smarthelp_final_intent_contact_options',
  pendingDisputes: 'GOPS_smarthelp_pending_disputes_alert',
};

export const elmoTreatmentNames = {
  kmSearchEnabled: 'Trmt_GOPS_Helpcenter_KM_Search_Enable',
  finalIntentContactOpsTrtm: 'Trmt_GOPS_Helpcenter_Final_Intent_Contact_Options_1',
  pendingDisputesNotification: 'Trmt_GOPS_Helpcenter_Pending_Disputes_Alert_Show',
};

export const isPartOfElmoExpTreatment = (elmoTreatments, treatmentName) => (Array.isArray(elmoTreatments) && elmoTreatments.indexOf(treatmentName) >= 0);
